var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 12.45l-12-12c-.3-.3-.6-.45-1.05-.45h-9C.6 0 0 .6 0 1.5v9c0 .45.15.75.45 1.05l12 12c.3.3.6.45 1.05.45.45 0 .75-.15 1.05-.45l9-9c.6-.6.6-1.5 0-2.1zM13.5 20.4L3 9.9V3h6.9l10.5 10.5-6.9 6.9z",
    fill: "#000"
  })));
}
export default SvgTag;